export var OrderKind;
(function (OrderKind) {
    OrderKind[OrderKind["Deposit"] = 0] = "Deposit";
    OrderKind[OrderKind["Redeem"] = 1] = "Redeem";
    OrderKind[OrderKind["Swap"] = 2] = "Swap";
})(OrderKind || (OrderKind = {}));
export function foldOrderKind(onDeposit, onRedeem, onSwap) {
    return (kind) => {
        switch (kind) {
            case OrderKind.Deposit:
                return onDeposit();
            case OrderKind.Redeem:
                return onRedeem();
            case OrderKind.Swap:
                return onSwap();
        }
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3BSZXF1ZXN0cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9hbW0vbW9kZWxzL29wUmVxdWVzdHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBZ0JBLE1BQU0sQ0FBTixJQUFZLFNBSVg7QUFKRCxXQUFZLFNBQVM7SUFDbkIsK0NBQU8sQ0FBQTtJQUNQLDZDQUFNLENBQUE7SUFDTix5Q0FBSSxDQUFBO0FBQ04sQ0FBQyxFQUpXLFNBQVMsS0FBVCxTQUFTLFFBSXBCO0FBRUQsTUFBTSxVQUFVLGFBQWEsQ0FDM0IsU0FBa0IsRUFDbEIsUUFBaUIsRUFDakIsTUFBZTtJQUVmLE9BQU8sQ0FBQyxJQUFlLEVBQUUsRUFBRTtRQUN6QixRQUFRLElBQUksRUFBRTtZQUNaLEtBQUssU0FBUyxDQUFDLE9BQU87Z0JBQ3BCLE9BQU8sU0FBUyxFQUFFLENBQUE7WUFDcEIsS0FBSyxTQUFTLENBQUMsTUFBTTtnQkFDbkIsT0FBTyxRQUFRLEVBQUUsQ0FBQTtZQUNuQixLQUFLLFNBQVMsQ0FBQyxJQUFJO2dCQUNqQixPQUFPLE1BQU0sRUFBRSxDQUFBO1NBQ2xCO0lBQ0gsQ0FBQyxDQUFBO0FBQ0gsQ0FBQyJ9